module.exports = __webpack_public_path__ + "static/media/house.6349ea3a.svg";